import React, {Component, Fragment} from "react";
import {Confirm, Menu, Dropdown} from "semantic-ui-react";
import {Link} from "react-router-dom";

interface IMenuProps {
    user:           string
    onClearSession: () => void
}

export default class TopMenu extends Component<IMenuProps> {
    state = {
        logout:     false,
        activeItem: "home"
    }

    render() {
        const {activeItem} = this.state
        return (
            <Fragment>
                <Confirm
                    open={this.state.logout}
                    size='tiny'
                    header='Logout confirmation'
                    content='Are you sure want to exit?'
                    onCancel={_ => this.setState({logout: false})}
                    onConfirm={_ => {
                        fetch('/session', {method: 'delete'})
                            .then(result => result.ok
                                ? this.props.onClearSession()
                                : alert("Logout false"))
                            .catch(error => alert(error))
                            .finally(() => this.setState({logout: false}));
                    }}
                />

                <Menu pointing secondary>
                   {["customers", "images", "disks", "software"].map((item: string, idx: number) => <Menu.Item key={idx} name={item} as={Link} to={item} active={activeItem === item} onClick={_ => this.setState({activeItem: item})}/>)}

                    <Menu.Menu position='right'>
                        <Dropdown item text={this.props.user}>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={e => this.setState({logout: true})}>Exit</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Menu>
                </Menu>
            </Fragment>
        )
    }
}
